import { FC, useMemo } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Grid } from 'swiper/modules';
import { HoroscopeIconType } from '../../Horoscopes/HoroscopesIcon/HoroscopesIcon-Constants';
import HoroscopesTile from '../HoroscopesTile/HoroscopesTile';
import { useTranslation } from 'react-i18next';
import { getTranslatedDateRange } from '../HoroscopesV2Util';
import 'swiper/css';
import 'swiper/css/grid';
import './HoroscopesCarousel.scss';

interface HoroscopesCarouselProps {
  onTileClick?: (sign: HoroscopeIconType) => void;
  className?: string;
  signOrder?: HoroscopeIconType[]; // Optional custom order for signs
}

export const HoroscopesCarousel: FC<HoroscopesCarouselProps> = ({ onTileClick, className = '', signOrder }) => {
  // Get all signs in order - use custom order if provided, otherwise default order
  const allSigns = useMemo(() => {
    if (signOrder && signOrder.length > 0) {
      // Ensure all signs are included (in case signOrder is incomplete)
      const defaultSigns = Object.values(HoroscopeIconType);
      const orderedSigns = signOrder.filter((sign) => defaultSigns.includes(sign));
      const missingSigns = defaultSigns.filter((sign) => !signOrder.includes(sign));
      return [...orderedSigns, ...missingSigns];
    }
    return Object.values(HoroscopeIconType);
  }, [signOrder]);
  const { t } = useTranslation();

  const handleTileClick = (sign: HoroscopeIconType) => {
    if (onTileClick) {
      onTileClick(sign);
    }
  };

  return (
    <div className={`horoscopes-carousel ${className}`}>
      <Swiper
        modules={[Grid]}
        slidesPerView={1.3}
        grid={{
          rows: 3,
          fill: 'row',
        }}
        spaceBetween={24}
        className="horoscopes-carousel__swiper"
        breakpoints={{
          300: {
            slidesPerView: 1.11,
            grid: {
              rows: 3,
            },
          },
          430: {
            slidesPerView: 1.25,
            grid: {
              rows: 3,
            },
          },
          720: {
            slidesPerView: 1.3,
            grid: {
              rows: 3,
            },
          },
        }}
      >
        {allSigns.map((sign) => (
          <SwiperSlide key={sign} className="horoscopes-carousel__slide">
            <HoroscopesTile
              sign={sign}
              date={getTranslatedDateRange(sign, t)}
              onClick={() => handleTileClick(sign)}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HoroscopesCarousel;

